import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  updateSO: null,
  loading: false,
  error: null,
};

const updateSOSlice = createSlice({
  name: "updateSO",
  initialState,
  reducers: {
    fetchUpdateSOStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchUpdateSOSuccess: (state, action) => {
      state.loading = false;
      state.updateSO = action.payload;
      state.error = null;
    },

    fetchUpdateSOFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchUpdateSOStart,
  fetchUpdateSOSuccess,
  fetchUpdateSOFailure,
} = updateSOSlice.actions;

export default updateSOSlice.reducer;